module.exports = __webpack_public_path__ + "img/qt_aquaristatqt.2e4d982.png";